import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import Header from '../layout/Header';
import DeparturesHeader from '../layout/DeparturesHeader';
import * as toursActions from '../../actions/tours';
import Map from '../Map';
import {Track, TrackedDiv, TrackDocument} from 'react-track';
import {monthsPeriod} from '../../api/monthsPeriod';
import Dimensions from 'react-dimensions'
import ReactDOM from 'react-dom';
import moment from 'moment';
import Translate from '../layout/Translate';
import Price from '../layout/Price';
import Gallery from './Gallery';
import Facebook from '../popups/Facebook';
import Day from './Day';
import Reviews from './Reviews';
import Discount from '../popups/Discount';
import TourSearchPreview from '../tours/SearchPreview';
import TourRelatedPreview from '../tours/RelatedPreview';
import ClickOutside from 'react-click-outside';

import {tween, combine} from 'react-imation';
import {rotate} from 'react-imation/tween-value-factories';
import {
    topTop,
    topBottom,
    centerCenter,
    topCenter,
    bottomBottom,
    bottomTop,
    getDocumentRect,
    getDocumentElement,
    calculateScrollY
} from 'react-track/tracking-formulas';
var Scroll = require('react-scroll');


var ScrollLink = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var ScrollElement = Scroll.Element;
var ScrollEvents = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;
var scroller = Scroll.scroller;


export default class SingleTour extends Component {

    rating(numrows) {
        var rows = [];
        for (var i = 1; i < numrows+1; i++) {
            rows.push(<div className="rate__star"></div>);
        }
        return rows;
    }


    changeTour() {


    }


    nextDay(offset, e) {
        this.props.actions.nextDay();
        scroll.scrollTo(offset + 200, {
            duration: 0,
            delay: 0,
            smooth: true
        });
    }

    selectDay(index, day, isMobile, e) {
        let actions = this.props.actions;
        if (day.programServices) {
            day.programServices.forEach(function(service, serviceIndex){
                if (service.type == 'overnight' && service.serviceSubitem && service.serviceSubitem.gallery_id) {
                    actions.fetchServiceGallery(service.serviceSubitem.gallery_id, (index)?index:0, serviceIndex);
                } else if (service.type == 'overnight' && service.serviceItem && service.serviceItem.gallery_id) {
                    actions.fetchServiceGallery(service.serviceItem.gallery_id, (index)?index:0, serviceIndex);
                }
            });
        }
        if (isMobile) {
            this.props.actions.toggleDay(index);
        } else {
            this.props.actions.selectDay(index);
        }
    }

    toggleDiscountInfo() {
        this.props.userActions.toggleDiscount();
    }

    toggleDeparture(departure, e) {
        this.props.actions.toggleDeparture(departure);
    }

    selectDeparture(tour, departure, e) {
        // this.props.actions.selectDeparture(departure);
        this.props.userActions.toggleFeedback(tour, departure);
    }


    selectTab(index) {
        this.props.actions.selectTab(index);
        scroller.scrollTo('departures', {
            duration: 400,
            delay: 0,
            smooth: true
        });

        let obj = this;
        setTimeout(function(){
            obj.props.actions.selectTab(index, true);
        }, 4000);

    }

    setVisibilityDayPhoto(visibility, e){
        if (!visibility) {
            this.props.actions.setViewDayPhoto(visibility);
        }
    }


    prevDay(offset, e) {
        this.props.actions.prevDay();
        scroll.scrollTo(offset, {
            duration: 0,
            delay: 0,
            smooth: true
        });
    }

    toggleFeedback(tour) {
        this.props.userActions.toggleFeedback(tour);
    }
    toggleShare() {

        addthis.toolbox('.addthis_toolbox');
        //console.info(addthis);
        this.props.userActions.toggleShare();
    }
    closeShare() {
        if (this.props.shareOpen) {
            this.props.userActions.toggleShare();
        }
    }
    testClass(offset, posTopTop) {
        /*
         let component = this;
         if (!this.pageIsScrolling) {

         this.pageIsScrolling = true;
         //console.info('testClass');

         scroll.scrollTo(offset, {
         duration: 500,
         delay: 0,
         smooth: true
         });

         ScrollEvents.scrollEvent.register('end', function(to, element) {
         component.pageIsScrolling = false;
         //console.info('end');
         ScrollEvents.scrollEvent.remove('end');
         });
         }
         ScrollEvents.scrollEvent.register('end', function(to, element) {

         //console.info('end');
         this.pageIsScrolling = false;
         ScrollEvents.scrollEvent.remove('end');
         });
         return 'test';
         */
    }


    closeDepartureTooltip() {
        this.props.actions.closeDepartureTooltip();
    }


    handleScroll(scrollY, topTop, topBottom) {
        let direction;
        let object = this;
        if(this.scrollPos > scrollY) {
            direction = -1;
            //    //console.log('top');
        } else if(this.scrollPos < scrollY) {
            direction = 1;
            //     //console.log('bottom');
        }
        // //console.log('diff:', Math.abs(this.lastScrollPos - scrollY));
        //   //console.log(scrollY);

        this.scrollPos = scrollY;

        if (scrollY < 100 && !this.showMap) {
            this.showMap = true;
            this.props.actions.setScroll({scrollY: scrollY, opacity: 1});
        } else if (scrollY > 100 && this.showMap) {
            this.showMap = false;
            this.props.actions.setScroll({scrollY: scrollY, opacity: 0});
        }
        //




    }

    componentWillMount() {
        this.blockedHover = false;



    }


    selectTour(tour) {
        this.props.actions.selectMapTour(tour);
        this.props.actions.fetchPostsIfNeeded(1, tour.id);
    }

    toggleDescription() {
        this.props.actions.toggleDescription();
    }

    componentDidMount() {


        this.centered = false;
        this.pageIsScrolling = false;
        this.lastScrollPos = 0;
        //this.headerHeight = React.findDOMNode(this.refs.tourHeader).clientHeight + React.findDOMNode(this.refs.tourContainer).offsetTop;


        this.mainInfoWidth = ReactDOM.findDOMNode(this.refs.tourContainer).clientWidth;
        this.screenHeight = ReactDOM.findDOMNode(this.refs.screen).clientHeight - 115;
        this.pageWidth = ReactDOM.findDOMNode(this.refs.mainInfo).clientWidth;
        //console.log('this.refs');
        //console.log(this.refs);

        //console.info('TOUR');
        if (this.props.tour.map_config) {

            if (!this.centered && this.props.tour.map_config) {
                //console.info(this.props.tour.map_config.center);
                this.props.actions.setMapConfig({
                    center: {
                        lat: this.props.tour.map_config.center.latitude,
                        lng: this.props.tour.map_config.center.longitude
                    },
                    zoom: this.props.tour.map_config.zoom,
                    type: 'ROADMAP'
                });
            }


            //      //console.log(this.props.tours.mapObject);
            //      //console.info(this.props.tours.mapHeight, React.findDOMNode(this.refs.mainInfo).clientHeight);

            //     var point = this.latLng2Point(this.props.tours.map.center, this.props.tours.mapObject);
            //     var coords = this.point2LatLng({x: point[0], y: point[1]}, this.props.tours.mapObject);
            //    //console.log('coords:', coords.lat(), coords.lng())
        }
    }


    componentDidUpdate() {


        this.screenHeight = ReactDOM.findDOMNode(this.refs.screen).clientHeight - 115;
        if (this.pageWidth != ReactDOM.findDOMNode(this.refs.mainInfo).clientWidth) {
            this.mainInfoWidth = ReactDOM.findDOMNode(this.refs.tourContainer).clientWidth;
            this.pageWidth = ReactDOM.findDOMNode(this.refs.mainInfo).clientWidth;

        }
        /*

         this.props.toursActions.setMapHeight(React.findDOMNode(this.refs.mainInfo).clientHeight);
         this.headerHeight = React.findDOMNode(this.refs.tourHeader).clientHeight + React.findDOMNode(this.refs.tourContainer).offsetTop;



         //console.log('CENTRED', this.centered);
         if (!this.centered && this.props.tour.map_config && this.props.tours.mapObject) {
         var lat = this.props.tours.map.center.lat;
         //console.log('heeeeIIIIGHt', this.headerHeight);
         //console.log(this.props.tours.mapObject);
         //console.log(this.props.tour.map_config);
         var position = this.latLng2Point(this.props.tours.map.center, this.props.tours.mapObject);
         //console.log('position', position);
         //console.log('fakePosition', React.findDOMNode(this.refs.mainInfo).clientHeight/2);
         var centerOffset = (React.findDOMNode(this.refs.mainInfo).clientHeight/2 + position[1])/2 - this.headerHeight;
         var offsetDifference = this.props.tour.map_config.center_offset - centerOffset;
         //console.log('centerOffset: ', centerOffset);
         //console.log('this.props.tour.map_config.center_offset: ', this.props.tour.map_config.center_offset);
         //console.log('offsetDifference: ', offsetDifference);
         var newCoordinates = this.point2LatLng({x: position[0], y: this.headerHeight + offsetDifference}, this.props.tours.mapObject);
         //console.info(newCoordinates);
         //console.info(lat - newCoordinates.lat(), newCoordinates.lng())
         //       this.props.toursActions.setCenter({lat: newCoordinates.lat(), lng: newCoordinates.lng()}, this.gMap);




         this.props.toursActions.setCenter({lat: this.props.tour.map_config.center.latitude, lng: this.props.tour.map_config.center.longitude});
         this.props.toursActions.setZoom(this.props.tour.map_config.zoom);

         this.centered = true;

         //  var point = this.latLng2Point(this.props.tours.map.center, this.props.tours.mapObject);
         //    var coords = this.point2LatLng({x: point[0], y: point[1]}, this.props.tours.mapObject);
         //   //console.log('coords:', coords.lat(), coords.lng())

         }
         */


    }



    componentWillReceiveProps() {


    }


    selectDestination(destination) {
        this.props.actions.selectDestination(destination);
        this.props.actions.fetchDestinationIfNeeded(destination.id);
        this.props.actions.toursSearch({d: destination.id});

        this.props.actions.setMapConfig({
            listByMap: false,
            forceListBySearch: true
        });
    }


    getNumEnding(iNumber, aEndings)
    {
        var sEnding, i;
        iNumber = iNumber % 100;
        if (iNumber>=11 && iNumber<=19) {
            sEnding=aEndings[2];
        }

        else {
            i = iNumber % 10;
            switch (i)
            {
                case (1): sEnding = aEndings[0]; break;
                case (2):
                case (3):
                case (4): sEnding = aEndings[1]; break;
                default: sEnding = aEndings[2];
            }
        }
        return sEnding;
    }


    render() {

        if (this.props.tour.months && this.props.tour.months.length) {
            if (this.props.tour.months.length == 12) {
                this.period = ['Круглый год', 'Круглый год']
            } else {
                this.period = monthsPeriod(this.props.tour.months, this.props.lang);
            }
        } else {
            this.period = ['', '']
        }

        const {tour, gallery, list, currency, selectedTab, width, reviews, openedReviews, lang} = this.props;

        this.minPrice = 0;
        this.minMonth = 0;
        this.maxMonth = 0;

        let endings = [<Translate slug="tour__day-1" />, <Translate slug="tour__day-2-4" />, <Translate slug="tour__day-5-0" />];
        tour.options = [];




        if (tour.departures) {
            let minDate = 0;
            let maxDate = 0;
            let minPrice = 0;
            tour.departures.sort(function (a, b) {
                if (a.start_at > b.start_at) {
                    return 1;
                }
                if (a.start_at < b.start_at) {
                    return -1;
                }
                return 0;
            });
            tour.departures.forEach(function (departure) {
                departure.now_date = new Date();
                departure.now_moment = moment(departure.now_date.getTime());

                departure.start_date = new Date(departure.start_at * 1000);
                departure.start_date_6 = new Date(departure.start_at * 1000);
                departure.start_date_6.setMonth(departure.start_date.getMonth()-6);

                departure.start_date_8 = new Date(departure.start_at * 1000);
                departure.start_date_8.setMonth(departure.start_date.getMonth()-8);

                departure.start_date_10 = new Date(departure.start_at * 1000);
                departure.start_date_10.setMonth(departure.start_date.getMonth()-10);

                departure.end_date = new Date(departure.end_at * 1000);
                departure.start_moment = moment(departure.start_at * 1000);
                departure.end_moment = moment(departure.end_at * 1000);
                if (lang == 'en') {
                    departure.formated_start_date = departure.start_moment.utc().format('MMMM, DD YYYY ');
                    departure.formated_end_date = departure.end_moment.utc().format('MMMM, DD YYYY');
                } else {
                    departure.formated_start_date = departure.start_moment.utc().format('DD.MM.YYYY ');
                    departure.formated_end_date = departure.end_moment.utc().format('DD.MM.YYYY');
                }
                departure.month_diff = departure.start_moment.diff(departure.now_moment, 'months');
                departure.diff = departure.start_moment.diff(departure.now_moment);

                //console.log(departure);

                if (!minDate || departure.start_at < minDate) {
                    minDate = departure.start_at;
                }

                if (!maxDate || departure.end_at > maxDate) {
                    maxDate = departure.end_at;
                }

                if (!minPrice || departure.price > minPrice) {
                    minPrice = departure.price;
                }

            });
            this.minMonth = new Date(minDate*1000).toLocaleString('ru', {
                month: 'long'
            });
            this.maxMonth = new Date(maxDate*1000).toLocaleString('ru', {
                month: 'long'
            });
            this.minPrice = minPrice;
        }


        let isMobile = (parseInt(this.pageWidth) < 700)?true:false;

        let shortDescription, shortDescriptionText = '', fullDescriptionText = '', hiddenText = '', htmlDescription, fewParagraphs, descriptionLength = 0, paragraphCount = 0;
        if (tour.content) {
        let autoParagraphList = tour.content.split('</p>');
        let paragraphList = [];




            autoParagraphList.forEach(function(paragraph, i){
                paragraph += '</p>';

                    let listByBr = paragraph.split('<br><br>');

                    listByBr.forEach(function(item, itemIndex){
                        let listItem = '';
                        if (itemIndex) {
                            listItem+= '<p>';
                        }
                        listItem+= item;


                        if (itemIndex != listByBr.length - 1) {
                            listItem+= '</p>';
                        }

                        paragraphList.push(listItem);
                        fullDescriptionText += listItem;
                    });

                    if (listByBr.length < 2) {

                    }

            });


        paragraphList.forEach(function(paragraph, i){

            if ( shortDescriptionText.length < 800) {
                paragraphCount++;
                shortDescriptionText+= paragraph;
                descriptionLength = shortDescriptionText.length;
            } else {
                hiddenText += paragraph;
            }




        });

        if (hiddenText.length > 500) {
            fewParagraphs = true;
        }


        if (paragraphList.length>2) {
            shortDescription = <div className="overview__paragraph"
                                    dangerouslySetInnerHTML={{__html:shortDescriptionText}}></div>;

        }
        htmlDescription = <div className="overview__paragraph"
                                   dangerouslySetInnerHTML={{__html:fullDescriptionText}}></div>;

        }

        let photoSize = 1400;
        let sizes = [2560, 1920, 1400, 1000];
        sizes.forEach(function(size){
            if (width && width <= size) {
                photoSize = size;
            }
        });

        if (tour.programDays) {
            tour.programDays.sort(function (a, b) {
                if (a.number > b.number) {
                    return 1;
                }
                if (a.number < b.number) {
                    return -1;
                }
                return 0;
            });
        }

        return (

            <div>






                <section className="section" ref="mainInfo">
                    <ScrollElement name="overview">
                        <div className="overview__screen" ref="screen">

                            <div className="section__content section__overview">
                                <ScrollElement name="map">
                                    <TrackDocument formulas={[getDocumentElement, getDocumentRect, calculateScrollY,
                               topTop, topBottom, topCenter, centerCenter, bottomBottom,
                               bottomTop]}>
                                        {(documentElement, documentRect, scrollY, topTop,
                                          topBottom, topCenter, centerCenter, bottomBottom, bottomTop) =>
                                            <div >


                                                <TrackedDiv formulas={[bottomBottom, topTop, bottomTop]}>
                                                    {(posBottomBottom, posTopTop, posBottomTop) =>
                                                        <div className={this.handleScroll(scrollY) + " overview__header_fixed " + ((scrollY > this.screenHeight - 600)?"overview__header_fixed_stopped":"") }
                                                             style={{top: ((scrollY > this.screenHeight - 600)?this.screenHeight - 600:0)}}
                                                        >


                                                            <Header />


                                                            <div className="container overview">
                                                                <h1>{tour.title}</h1>
                                                                {tour.destinations &&
                                                                <div className="overview__destination">
                                                                    <span className="overview__destination_label"><Translate slug="tour__destination" />: </span>
                                                                    {tour.destinations.map((destination, i)=>
                                                                        <span>
                                                                            {!!destination.is_published &&
                                                                                <Link key={'destination' + i} to={"/destinations/" + destination.slug} onClick={this.selectDestination.bind(this, destination)}>
                                                                                    {destination.title} {tour.destinations.length > i+1 && ', '}
                                                                                </Link>
                                                                            }
                                                                            {!destination.is_published &&
                                                                                <span key={'destination' + i} >
                                                                                    {destination.title} {tour.destinations.length > i+1 && ', '}
                                                                                </span>
                                                                            }
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                }
                                                            </div>

                                                            <div className="overview__info">
                                                                <Link to="/map" className="overview__info-button"><Translate slug="tour__detail-route" /></Link>
                                                            </div>

                                                        </div>
                                                    }</TrackedDiv>

                                            </div>
                                        }
                                    </TrackDocument>


                                </ScrollElement>
                            </div>



                            <div className="overview__summary">

                                <div className="container overview" ref="tourContainer">


                                    <div className="overview__items">
                                        <div className="overview__summary-info ">
                                            <div className="rate">

                                                <div>
                                                    {this.rating(5).map((point, i) =>
                                                        <div key={'rate' + i}
                                                             className={"rate__star " + (parseInt(tour.complexity_rate) > i ? 'rate__star_active' : '')}>
                                                            <div className={"tooltip rate__tooltip " + ((parseInt(tour.complexity_rate)==i+1)?"rate__tooltip_current":"")}>
                                                                <Translate slug={"tour__complexity_" + (i+1)} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="rate__label">
                                                    <Translate slug="tour__complexity" />
                                                </div>

                                            </div>
                                        </div>
                                        <div className="overview__summary-info ">
                                            <div className="rate">


                                                <div>
                                                    {this.rating(3).map((point, i) =>
                                                        <div key={'service' + i}
                                                             className={"rate__star " + (parseInt(tour.service_rate) > i ? 'rate__star_active' : '')}>
                                                            <div className={"tooltip rate__tooltip " + ((parseInt(tour.service_rate)==i+1)?"rate__tooltip_current":"")}>
                                                                <Translate slug={"tour__service_" + (i+1)} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="rate__label">
                                                    <Translate slug="tour__service" />
                                                </div>
                                            </div>

                                        </div>
                                        <div className="overview__summary-info overview__summary-info_type">
                                            <div className={"overview__type-icon overview__type-icon_" + tour.type}></div>
                                        </div>
                                        <div className="overview__summary-info overview__summary-info_age">
                                            <div className={"overview__age overview__age_" + tour.min_age}>

                                                <div className="tooltip rate__tooltip">
                                                    <Translate slug="tour__age__comment" />
                                                </div>
                                            </div>

                                        </div>
                                        <div className="overview__summary-info overview__days">{tour.days_count} <span
                                            className="overview__uppercase-label">{this.getNumEnding(tour.days_count, endings)}</span></div>
                                        {this.period &&
                                        <div className="overview__summary-info overview__months"><span
                                            className="overview__uppercase-label">{this.period[0]}</span>
                                            {this.period[0] != this.period[1] &&
                                            <span> - <span className="overview__uppercase-label">{this.period[1]}</span></span>
                                            }
                                        </div>
                                        }


                                    </div>

                                    {!!parseFloat(tour.min_price) &&

                                    <button className={"overview__price overview__price_" + this.props.lang} onClick={this.selectTab.bind(this, 0)}>
                                        <div className="overview__valute"><div className="overview__from"><Translate slug="price" /></div><span><Translate slug="price__from" /></span></div>
                                        <Price price={tour.min_price} crop={true} currency={((tour.currency_id)?tour.currency_id:'RUR')} />
                                    </button>

                                    }

                                    <div className="">




                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="section__tour">
                            <div className="container overview">
                                <div className="overview__text">
                                    <div className="overview__strongpoints">
                                        <div className="overview__title"><Translate slug="tour__strong-points" /></div>
                                        <ul className="overview__list">
                                            {tour.strong_points &&
                                            <div>
                                                {tour.strong_points.map((point, i) =>
                                                    <li key={'point' + i} className="overview__list-item">
                                                        {point}
                                                    </li>
                                                )}
                                            </div>
                                            }

                                        </ul>
                                    </div>
                                    <div className="overview__description">
                                        <div className="overview__title"><Translate slug="tour__information" /></div>
                                        {(!tour.showDescription && fewParagraphs) &&
                                            <div>
                                                {shortDescription}
                                                <div className="overview__paragraph_hidden"
                                                     dangerouslySetInnerHTML={{__html: hiddenText}}></div>
                                                <div className="overview__more"
                                                     onClick={this.toggleDescription.bind(this)}>
                                                    <Translate slug="overview__more"/>
                                                </div>
                                            </div>
                                        }
                                        {(tour.showDescription || !fewParagraphs) && htmlDescription}

                                    </div>

                                </div>

                            </div>
                        </div>


                    </ScrollElement>
                </section>

                <Gallery gallery={gallery} offset={(this.pageWidth - this.mainInfoWidth) / 2} size={photoSize} actions={this.props.actions} />





                {tour.programDays &&
                <div>


                    <div>
                        <TrackedDiv formulas={[bottomBottom, topTop, bottomTop]}>
                            {(posBottomBottom, posTopTop, posBottomTop) =>
                                <ScrollElement name="program">
                                    <section ref="program"
                                             className={"section section__program"}>

                                        <div
                                            className={"container program " + ((tour.viewDayPhoto)?"program_hidden":"")}>


                                            {(isMobile || typeof tour.activeDay != 'number') &&
                                            <div>

                                                <div className="program__header">
                                                    <div className="program__title">
                                                        <Translate slug="tour__program__title"/>
                                                    </div>
                                                </div>
                                                <ul className="program__list">

                                                    {tour.programDays.sort(function (a, b) {
                                                        if (a.number > b.number) {
                                                            return 1;
                                                        }
                                                        if (a.number < b.number) {
                                                            return -1;
                                                        }
                                                        return 0;
                                                    }).map((day, i) =>
                                                        <li className="program__item"
                                                            key={'numbers' + day.number + i}
                                                        >

                                                            <div className="program__wrap" onClick={this.selectDay.bind(this, i, day, isMobile)}>
                                                                <div className="program__number">
                                                                    <Translate
                                                                        slug="tour__program__day"/> {i + 1}
                                                                </div>
                                                                <div
                                                                    className="program__name">{day.title}</div>
                                                                <div className="program__location">
                                                                    {day.start}
                                                                    {(day.end && (day.end != day.start) && day.start) &&
                                                                    <span>
                                                                                            &nbsp;&mdash;&nbsp;
                                                                                        </span>
                                                                    }
                                                                    {day.end}
                                                                </div>
                                                                <div className="clearfix"></div>
                                                            </div>

                                                            {isMobile &&
                                                            <Day day={day}
                                                                 active={tour.activeDay == i}
                                                                 mobile={true}
                                                                 actions={this.props.actions}/>
                                                            }
                                                        </li>
                                                    )}

                                                </ul>
                                            </div>
                                            }
                                            {(!isMobile && typeof tour.activeDay == 'number') &&
                                            <div>
                                                <div className="program__header">
                                                    <div
                                                        className="program__title program__title_active"
                                                        onClick={this.selectDay.bind(this, null, {}, isMobile)}>
                                                        <div
                                                            className="program__number program__number_absolute program__number_inactive">
                                                            <Translate
                                                                slug="tour__program__back"/>
                                                        </div>
                                                        {tour.programDays[tour.activeDay].title}
                                                    </div>
                                                </div>
                                                <ul className="program__list program__list_numbers">

                                                    {tour.programDays.sort(function (a, b) {
                                                        if (a.number > b.number) {
                                                            return 1;
                                                        }
                                                        if (a.number < b.number) {
                                                            return -1;
                                                        }
                                                        return 0;
                                                    }).map((day, i) =>
                                                        <li className="program__item program__item_collapsed"

                                                            key={'list' + day.number + i}
                                                            onClick={this.selectDay.bind(this, i, day, isMobile)}
                                                        >
                                                            <div
                                                                className={'program__number ' + (tour.activeDay==i?'program__number_active':'program__number_inactive')}>
                                                                <Translate
                                                                    slug="tour__program__day"/> {i + 1}
                                                            </div>
                                                        </li>
                                                    )}

                                                </ul>
                                            </div>
                                            }
                                            {tour.programDays.sort(function (a, b) {
                                                if (a.number > b.number) {
                                                    return 1;
                                                }
                                                if (a.number < b.number) {
                                                    return -1;
                                                }
                                                return 0;
                                            }).map((day, i) =>
                                                <div
                                                    key={'item' + day.number + i}>
                                                    {!isMobile &&
                                                    <Day day={day} active={tour.activeDay == i} mobile={false}
                                                         actions={this.props.actions}/>
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    </section>
                                </ScrollElement>
                            }
                        </TrackedDiv>
                    </div>
                    <div>
                        <TrackedDiv formulas={[bottomBottom, topTop, bottomTop]}>
                            {(posBottomBottom, posTopTop, posBottomTop) =>
                                <div>

                                    <section className="section departures">
                                        <ScrollElement name="tdepart">
                                            <ScrollElement name="departures">
                                            </ScrollElement>
                                            <Discount open={this.props.discountOpen}
                                                      toggle={this.props.userActions.toggleDiscount}/>


                                            {!isMobile &&
                                            <div className=" container ">
                                                <div className="tab-set ">
                                                    <div className="tab-set__container">
                                                        <button href="#"
                                                                className={"tab-set__item " + (selectedTab == 0?'tab-set__item_active':'')}
                                                                onClick={this.selectTab.bind(this, 0)}>
                                                            <Translate slug="tour__departures"/>
                                                        </button>
                                                        <button
                                                            className={"tab-set__item " + (selectedTab == 1?'tab-set__item_active':'')}
                                                            onClick={this.selectTab.bind(this, 1)}>
                                                            <Translate
                                                                slug="tour__included__title"/>
                                                        </button>
                                                        {tour.detailedFile &&
                                                        <a href={tour.detailedFile} target="_blank"
                                                           className={"tab-set__item tab-set__item_download"}>
                                                            <Translate
                                                                slug="tour__detailed__title"/>
                                                        </a>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            }



                                            <div
                                                className={"departures__container container " + (( selectedTab != 0)?'container_hidden':'')}>

                                                {false &&
                                                <div className="discount-comment">
                                                    <Translate slug="tour__discount__info"/>
                                                    <button className="discount-comment__button"
                                                            onClick={this.toggleDiscountInfo.bind(this)}>
                                                        <Translate slug="tour__discount__more"/>
                                                    </button>
                                                </div>
                                                }
                                                {tour.departures && !tour.departures.length &&
                                                    <table className="table">

                                                        <tbody>

                                                        <tr className="tour__row">
                                                            <td className="table__col table__col_empty" >
                                                                <Translate slug="departures__empty"/>
                                                            </td>
                                                            <td className="table__col table__col_button table__col_align_right">
                                                                <div className="table__buttons">
                                                                    <button className="table__button" onClick={this.toggleFeedback.bind(this, tour)}>
                                                                        <Translate slug="tour__inquiry"/>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>



                                                        </tbody>
                                                    </table>
                                                }
                                                {tour.departures && !!tour.departures.length &&

                                                <div className="">
                                                    <div className="tour__title"><Translate slug="tour__departures"/></div>
                                                    <div className="departures__list">
                                                        <table className="table">

                                                            {tour.departures.map((departure, i) =>
                                                                <tbody key={departure.id}
                                                                       className={((departure.opened)?'departure_open':'')}>

                                                                <tr className="tour__row">
                                                                    <td className="table__col table__col_price" >
                                                                        <div className="table__item table__date">{departure.formated_start_date}<div className="table__note"><Translate slug="tour__start"/></div></div>
                                                                        <span style={{verticalAlign: 'top'}}> - </span>
                                                                        <div className="table__item table__date">{departure.formated_end_date}<div className="table__note"><Translate slug="tour__end"/></div></div>
                                                                    </td>
                                                                    <td className="table__col">
                                                                        <div className="table__item departure__status departure__status_closed">
                                                                            {!departure.quota &&
                                                                            <span
                                                                                className="departure__status departure__status_closed">
                                                                                        <Translate
                                                                                            slug="departure__status_closed"/>
                                                                                    </span>
                                                                            }
                                                                            {!!(departure.quota && departure.quota <= 4) &&
                                                                            <span
                                                                                className="departure__status departure__status_closed">
                                                                                        <Translate
                                                                                            slug="departure__status_open"/> {departure.quota}
                                                                                    </span>
                                                                            }
                                                                            {!!(departure.quota && departure.quota > 4) &&
                                                                            <span
                                                                                className="departure__status ture__status_closed">
                                                                                        <Translate
                                                                                            slug="departure__status_open"/> 4+
                                                                                    </span>
                                                                            }
                                                                            <div className="table__note"><Translate slug="tour__status"/></div>
                                                                        </div>
                                                                    </td>
                                                                    <td className="table__col table__price table__col_align_right">
                                                                        <div className="table__price departure__price">
                                                                            {departure.price &&
                                                                            <span className="departure__price">
                                                                                                <Price price={departure.price}
                                                                                                       currency={departure.currency_id}/>
                                                                                            </span>
                                                                            }
                                                                            <div className="table__note"><Translate slug="tour__base-price"/></div>
                                                                        </div>
                                                                    </td>
                                                                    <td className="table__col table__col_button table__col_align_right">
                                                                        <div className="table__buttons">
                                                                            <button className={"table__button " + ((!departure.quota && tour.indicateButton)?"table__button_indicate":"") + (!departure.quota ? ' table__button_disabled' : '')} disabled={!departure.quota} onClick={this.selectDeparture.bind(this, tour, departure)}>
                                                                                <Translate slug="tour__buy"/>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>



                                                                </tbody>
                                                            )}
                                                        </table>

                                                    </div>
                                                </div>
                                                }



                                                {(tour.options && tour.options.length > 0) &&
                                                <div className="departures__info">
                                                    <div className="departures__title"><Translate
                                                        slug="tour__options"/>
                                                    </div>
                                                    <p className=""><Translate
                                                        slug="tour__options__note"/></p>
                                                    <table className="departures__options">
                                                        <tbody>
                                                        {tour.options.map((option, i) =>
                                                            <tr className="departures__row"
                                                                key={'option' + i}>
                                                                <td className="departures__col">{option.title} </td>
                                                                <td className="departures__col"><Price
                                                                    price={option.price}
                                                                    currency={tour.departures[0].currency_id}/>
                                                                </td>
                                                            </tr>
                                                        )}
                                                        </tbody>

                                                    </table>
                                                </div>
                                                }



                                            </div>

                                            <div
                                                className={" container " + ((!isMobile && selectedTab != 1)?'container_hidden ':' ') + (isMobile?'departures__container':'')}>
                                                {isMobile &&
                                                <div className="tour__title">
                                                    <Translate
                                                        slug="tour__included__title"/>
                                                </div>
                                                }
                                                <div className="included-list">
                                                    <div className="included-list__title">
                                                        <Translate slug="tour__included__list"/>
                                                    </div>
                                                    {tour.lists.includedList &&
                                                    <ul className="included-list__items">
                                                        {tour.lists.includedList.map((item, i)=>
                                                            <li key={'included' + i}
                                                                className="included-list__item">{item}</li>
                                                        )}
                                                    </ul>
                                                    }
                                                </div>
                                                <div className="included-list__title">
                                                    <Translate slug="tour__not-included__list"/>
                                                </div>

                                                {tour.lists.notIncludedList &&
                                                <ul className="included-list__items">
                                                    {tour.lists.notIncludedList.map((item, i)=>
                                                        <li key={'notIncluded' + i}
                                                            className="included-list__item included-list__item_no">{item}</li>
                                                    )}
                                                </ul>
                                                }
                                                <div className="disclaimer">
                                                    <Translate slug="tour__included__disclaimer"/>
                                                </div>

                                                {tour.note &&
                                                <div className="departures__info">
                                                    <div className="departures__title"><Translate
                                                        slug="tour__note"/></div>
                                                    <p className="departures__text">
                                                        {tour.note}
                                                    </p>
                                                </div>
                                                }
                                            </div>

                                            <div className=" container">
                                                <Reviews
                                                    reviews={reviews}
                                                    openedReviews={openedReviews}
                                                    reviewsLang={this.props.reviewsLang}
                                                    reviewsPopupOpen={this.props.reviewsPopupOpen}
                                                    reviewsPageCount={this.props.reviewsPageCount}
                                                    fetchReviews={this.props.fetchReviews}
                                                    destinations={tour.destinations}
                                                    tourId={tour.id}
                                                    lang={this.props.lang}
                                                    actions={this.props.actions}
                                                    userActions={this.props.userActions}
                                                />

                                                <div className="related__container">
                                                    <div className="tour__title"><span><Translate
                                                        slug="tour__related"/>
                                                                                </span></div>
                                                    <div className="related">
                                                        {!!tour.promo.length &&
                                                        <Link to={"/promo/" + tour.promo[0].slug}
                                                              className={'related__tour promo-item'}
                                                              style={{
                                                                                            backgroundImage: 'url('+ ((tour.promo[0].coverImages && tour.promo[0].coverImages.previews)?tour.promo[0].coverImages.previews.original +')':'#000')
                                                                                         }}
                                                        >
                                                                                        <span className="promo-item__title">
                                                                                            {tour.promo[0].title}
                                                                                            <Translate
                                                                                                slug="filter__all-tours"/>
                                                                                        </span>
                                                        </Link>
                                                        }

                                                        {tour.related.map((relatedTour, i) =>
                                                            <div key={'related' + i}
                                                                 className={'related__tour ' + ((i==3 || (i == 2 && tour.promo.length))?'related__tour_last':'')}>
                                                                {((i < 3 && tour.promo.length) || (i < 4 && !tour.promo.length)) &&
                                                                <TourSearchPreview key={i}
                                                                                   tour={relatedTour}
                                                                                   lang={this.props.lang}
                                                                                   toggleMenu={function(){}}
                                                                                   selectTour={this.props.actions.selectTour}
                                                                                   loadTour={this.props.actions.fetchPostsIfNeeded}
                                                                                   fetchReviews={this.props.actions.fetchReviews}
                                                                />

                                                                }

                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </ScrollElement>
                                    </section>

                                    <Facebook blockClass={"facebook_tour"} />

                                    <div className="footer__registration">
                                        <Translate
                                            slug="main__registration"/>
                                    </div>


                                </div>
                            }

                        </TrackedDiv>

                    </div>
                </div>

                }




            </div>

        );
    }
}




// WEBPACK FOOTER //
// ./src/common/components/tour/SingleTour.js